// #standard page 
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setActivePage } from '../../redux/actions';
import PageTitle from '../../components/PageTitle';

//#table
import GenericTable from '../../components/GenericTable';
import { dateFormat, currencyFormat, csvNumberFormat } from '../../helpers/formatter';
import StatisticsWidget from '../../components/StatisticsWidget';

//#form
import {
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';

//#other
import classnames from 'classnames';
import { fetchJSON } from '../../helpers/api';
import { getGenericAttributeFromToken } from '../../helpers/authUtils';




// get user generic attribute
const objGenericAttribute = getGenericAttributeFromToken();

const columns = [
    {
        dataField: 'expiryDate',
        text: 'LC Expiry',
        sort: true,
        formatter: dateFormat,
        csvFormatter: dateFormat,
        style: { whiteSpace: 'nowrap' },
        headerStyle: { whiteSpace: 'nowrap' },
    },
    {
        dataField: 'leaseNo',
        text: 'Ref',
        sort: true,
    },
    {
        dataField: 'automaticRenewal',
        text: 'Automatic Renewal',
    }
    , {
        dataField: 'msnRef',
        text: 'Serial No.',
        sort: true
    },
    {
        dataField: 'locType',
        text: 'LOC Type',
        sort: true
    },
    {
        dataField: 'amountHeld',
        text: 'Amount Held',
        headerClasses: 'numberColumn',
        classes: 'numberColumn',
        formatter: currencyFormat,
        csvFormatter: csvNumberFormat
    },
    {
        dataField: 'issuingBank',
        text: 'Issuing Bank',
        sort: true
    },
    {
        dataField: 'issuingBankReference',
        text: 'Issuing Bank Ref.',
        sort: true,
        hidden: objGenericAttribute.ServicedEntityAccess === 'Y'
    },
    {
        dataField: 'issuingBankCity',
        text: 'Issuing Bank City',
        sort: true,
        hidden: objGenericAttribute.ServicedEntityAccess === 'Y'
    },
    {
        dataField: 'confirmingBank',
        text: 'Confirming Bank',
        sort: true
    },
    {
        dataField: 'confirmingBankReference',
        text: 'Confirming Bank Ref.',
        sort: true,
        hidden: objGenericAttribute.ServicedEntityAccess === 'Y'
    },
    {
        dataField: 'advisingBank',
        text: 'Advising Bank',
        sort: true
    }
];

const columnsSummary = [
    {
        dataField: 'partyName',
        text: 'Lessee',
        sort: true
    },
    {
        dataField: 'expiryDate',
        text: 'LC Expiry',
        sort: true,
        formatter: dateFormat,
        csvFormatter: dateFormat,
        style: { whiteSpace: 'nowrap' },
        headerStyle: { whiteSpace: 'nowrap' },
    },
    {
        dataField: 'leaseNo',
        text: 'Ref',
        sort: true,
    },
    {
        dataField: 'automaticRenewal',
        text: 'Automatic Renewal',
    }
    , {
        dataField: 'msnRef',
        text: 'Serial No.',
        sort: true
    },
    {
        dataField: 'locType',
        text: 'LOC Type',
        sort: true
    },
    {
        dataField: 'amountHeld',
        text: 'Amount Held',
        headerClasses: 'numberColumn',
        classes: 'numberColumn',
        formatter: currencyFormat,
        csvFormatter: csvNumberFormat
    },
    {
        dataField: 'issuingBank',
        text: 'Issuing Bank',
        sort: true
    },
    {
        dataField: 'issuingBankReference',
        text: 'Issuing Bank Ref.',
        sort: true,
        hidden: objGenericAttribute.ServicedEntityAccess === 'Y'
    },
    {
        dataField: 'issuingBankCity',
        text: 'Issuing Bank City',
        sort: true,
        hidden: objGenericAttribute.ServicedEntityAccess === 'Y'
    },
    {
        dataField: 'confirmingBank',
        text: 'Confirming Bank',
        sort: true
    },
    {
        dataField: 'confirmingBankReference',
        text: 'Confirming Bank Ref.',
        sort: true,
        hidden: objGenericAttribute.ServicedEntityAccess === 'Y'
    },
    {
        dataField: 'advisingBank',
        text: 'Advising Bank',
        sort: true
    }
];


const defaultSorted = [
    {
        dataField: 'expiryDate',
        order: 'asc',
    },
];

class LettersOfCredit extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loading: true,
            expiringLOC: [],
            error: false,
            tabHeadings: [],
            activeTab: '0',
            columns: columns,
        };
    }

    componentDidMount = () => {
        this.props.setActivePage();

        this.loadLettersOfCredit();

        // get expiring LOCs
        this.loadExpiringLOC();
    };

    async loadExpiringLOC() {
        let url = '/portal/LeaseAccount/GetExpiringLOC';
        let response = await fetchJSON(url);
        this.setState({
            expiringLOC: response.data,
            error: response.error
        });
    }

    async loadLettersOfCredit() {
        let url = '/portal/LeaseAccount/GetLettersOfCredit';
        let response = await fetchJSON(url);
        let lessees = [...new Set(response.data.map(({ partyName }) => partyName))];
        this.setState({
            data: response.data,
            loading: response.loading,
            error: response.error,
            tabHeadings: [...lessees]
        });

        // multiple tabs (serviced entities)
        if (lessees.length > 1) {
            this.setState({
                columns: columnsSummary,
            });
        }
    }


    /**
    * Toggle the tab
    */
    toggle = (tab: string) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
                columns: tab === "0" ? columnsSummary : columns
            });
        }
    };


    render() {
        return (
            <React.Fragment>
                <PageTitle
                    breadCrumbItems={[
                        { label: 'Letters Of Credit', path: '/LeaseAccount/LettersOfCredit', active: true },
                    ]}
                    title={'Letters Of Credit'}
                    error={this.state.error}
                />
                <Row>
                    <Col>
                        <Card>
                            <CardHeader>
                                <Row>
                                    {this.state.expiringLOC.map((item) => {
                                        if (item.DaysExpiry === 15) {
                                            return (
                                                <React.Fragment key={item.daysExpiry}>
                                                    <Col sm={4}>
                                                        <StatisticsWidget
                                                            icon="mdi mdi-timer"
                                                            description="Letters of credit expiring in next 15 days"
                                                            title="Letters of credit expiring in next 15 days"
                                                            stats={item.NoLocs}
                                                        ></StatisticsWidget>
                                                    </Col>
                                                </React.Fragment>
                                            );
                                        }
                                        else if (item.DaysExpiry === 30) {
                                            return (
                                                <React.Fragment key={item.daysExpiry}>
                                                    <Col sm={4}>
                                                        <StatisticsWidget
                                                            icon="mdi mdi-timer"
                                                            description="Letters of credit expiring in next 30 days"
                                                            title="Letters of credit expiring in next 30 days"
                                                            stats={item.NoLocs}
                                                        ></StatisticsWidget>
                                                    </Col>
                                                </React.Fragment>
                                            );
                                        }
                                        else if (item.DaysExpiry === 60) {
                                            return (
                                                <React.Fragment key={item.daysExpiry}>
                                                    <Col sm={4}>
                                                        <StatisticsWidget
                                                            icon="mdi mdi-timer"
                                                            description="Letters of credit expiring in next 60 days"
                                                            title="Letters of credit expiring in next 60 days"
                                                            stats={item.NoLocs}
                                                        ></StatisticsWidget>
                                                    </Col>
                                                </React.Fragment>
                                            );
                                        }
                                        else {
                                            return '';
                                        }
                                    })}
                                    <Col sm={2}>
                                        {' '}
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <React.Fragment>
                                    {/* Single party */}
                                    {this.state.tabHeadings.length <= 1 && (
                                        <GenericTable
                                            columns={columns}
                                            data={this.state.data}
                                            keyField='id'
                                            defaultSorted={defaultSorted}
                                            loading={this.state.loading}
                                            exportListName='LOCs'
                                        />
                                    )}

                                    {/* Multiple parties */}
                                    {this.state.tabHeadings.length > 1 && (
                                        <React.Fragment>
                                            <Nav tabs className="nav-bordered">
                                                {this.state.tabHeadings.map((tab, index) => {
                                                    return (
                                                        <NavItem key={index}>
                                                            <NavLink
                                                                href="#"
                                                                className={classnames({ active: this.state.activeTab === index.toString() }, { 'bg-light-lighten': index === 0 })}
                                                                onClick={() => {
                                                                    this.toggle(index.toString());
                                                                }}>
                                                                <span>{tab}</span>
                                                            </NavLink>
                                                        </NavItem>
                                                    );
                                                })}
                                            </Nav>

                                            <br />
                                            <GenericTable
                                                columns={this.state.columns}
                                                data={this.state.data.filter(l => (this.state.activeTab === "0" && l.partyName !== this.state.tabHeadings[this.state.activeTab]) || (this.state.activeTab !== "0" && l.partyName === this.state.tabHeadings[this.state.activeTab]))}
                                                keyField='id'
                                                defaultSorted={defaultSorted}
                                                loading={this.state.loading}
                                                exportListName='LOCs'
                                            />
                                        </React.Fragment>
                                    )}
                                </React.Fragment>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setActivePage: () => {
            dispatch(setActivePage("LeaseAccount_LettersOfCredit"));
        }
    };
}

export default withRouter(
    connect(null, mapDispatchToProps)(LettersOfCredit)
);